/**
 * Flags enum.
 */
export enum FeatFlag {
  DEPTH_PEELING = 'DEPTH_PEELING',
  WIREFRAME_FABRICS = 'WIREFRAME_FABRICS',
  DISABLE_TRANSPARENCY_FLAT_COMPENSATION = 'DISABLE_TRANSPARENCY_FLAT_COMPENSATION',
  DISABLE_TRANSPARENCY_ANGLE_BASED_COMPENSATION = 'DISABLE_TRANSPARENCY_ANGLE_BASED_COMPENSATION',
  PARALLAX = 'PARALLAX',
  PREMULTIPLIED_ALPHA_LOGOS = 'PREMULTIPLIED_ALPHA_LOGOS',
}

/**
 * Flags state.
 */
export type FeatureFlagsState = {
  depthPeelingLayers: number;
  disableTransparencyAngleBasedCompensation: boolean;
  disableTransparencyFlatCompensation: boolean;
  parallax: boolean;
  premultipliedAlphaLogos: boolean;
  wireframeFabrics: boolean;
};
